module.exports = __webpack_public_path__ + "img/uk-diabetes-mellitus-male.8aabbdd0.png";